
<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="6">
        <div class="cy-floor">
          <v-select
            id="floor"
            clearable
            v-model="floor"
            :error="$store.state.error.state('floor')"
            :error-messages="$store.state.error.get('floor')"
            :items="$store.getters.building.floors"
            :label="$t('Floor')"
      
          >
            <template #item="{ item }">
              {{ item + $t(". floor") }}
            </template>
            <template #selection="{ item }">
              {{ item + $t(". floor") }}
            </template>
          </v-select>
        </div>
      </v-col>
      <v-col cols="12" md="6">
        <div class="cy-apartment">
          <v-select
            id="apartment_id"
            v-model="apartmentId"
            :items="apartments"
            :label="$t('Apartment number')"
            :error="$store.state.error.state('apartment_id')"
            :error-messages="$store.state.error.get('apartment_id')"
            item-text="title"
            item-value="id"

          >
            <template #item="{ item }">
              <div v-html="apartmentTitle(item)"></div>
            </template>
            <template #selection="{ item }">
              <div v-html="apartmentTitle(item)"></div>
            </template>
          </v-select>
        </div>
      </v-col>
    </v-row>
    <!-- <pre>apartment: {{ this.$store.getters.apartment }}</pre> -->
  </v-container>
</template>


<script>
import updateRouteQuery from "@/actions/updateRouteQuery";
import syncFromQueryParams from "@/actions/syncFromQueryParams";
export default {
  mounted() {
    syncFromQueryParams(this.$route);
    // this.syncFromQueryParams();
  },

  computed: {
    floor: {
      get() {
        return this.$store.state.floor;
      },
      set(value) {
        const updatables = { floor: value, apartment_id: null };
        this.$store.commit("SET", updatables);
        updateRouteQuery(this.$route, updatables);
      },
    },

    apartments() {
      return this.floor ? this.$store.getters.floorApartments : this.$store.getters.apartments;
    },

    apartmentId: {
      get() {
        return this.$store.state.apartment_id;
      },
      set(value) {
        const updatables = { apartment_id: value, floor: null };

        const apartment = value !== null ? this.apartments.find((item) => item.id === value) : null;
        if (apartment && apartment.floor) {
          updatables.floor = apartment.floor;
        }
        this.$store.commit("SET", updatables);
        updateRouteQuery(this.$route, updatables);
      },
    },
  },
  methods: {
    apartmentTitle(item) {
      const title = this.$t(item.title);
      const number = item.number;
      const rooms = this.$t("{0} rooms", [item.rooms]);

      return `${title} ${number} <small>(${rooms})</small>`;
    },
    syncFromQueryParams() {
      const apartmentId = this.$route.query.apartment_id;
      con.floor = this.$route.query.floor;
      if (apartmentId) {
        this.apartmentId = parseInt(apartmentId);
      } else if (floor) {
        this.floor = parseInt(floor);
      }
    },
  },
};
</script>
